import { render } from "./generate-reporte.vue?vue&type=template&id=d82c94e2"
import script from "./generate-reporte.vue?vue&type=script&lang=js"
export * from "./generate-reporte.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__